import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, formatApiError } from '../../lib/api';
import { RepairImagesCard } from '../../components/admin/RepairImagesCard';

const Stat = ({ label, value, to }) => (
  <Link
    to={to}
    className="block bg-white border border-gray-200 p-8 hover:border-[#d94e47] transition-colors"
    data-testid={`stat-${label.toLowerCase()}`}
  >
    <p className="text-xs font-light tracking-[0.2em] uppercase text-gray-500">{label}</p>
    <p className="text-5xl font-light mt-4">{value}</p>
  </Link>
);

const Dashboard = () => {
  const [counts, setCounts] = useState({ projects: '—', news: '—' });
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const [p, n] = await Promise.all([
          api.get('/admin/projects'),
          api.get('/admin/news'),
        ]);
        setCounts({ projects: p.data.length, news: n.data.length });
      } catch (e) {
        setError(formatApiError(e));
      }
    })();
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <h1 className="text-4xl font-light mb-2">Tableau de bord</h1>
      <p className="text-gray-500 font-light mb-10">
        Gérez les projets, actualités et la philosophie de l'agence.
      </p>

      {error && (
        <p className="text-[#d94e47] font-light mb-6" data-testid="dashboard-error">{error}</p>
      )}

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Stat label="Projets" value={counts.projects} to="/admin/projects" />
        <Stat label="Actualités" value={counts.news} to="/admin/news" />
        <Link
          to="/admin/philosophy"
          className="block bg-white border border-gray-200 p-8 hover:border-[#d94e47] transition-colors"
          data-testid="stat-philosophy"
        >
          <p className="text-xs font-light tracking-[0.2em] uppercase text-gray-500">Philosophie</p>
          <p className="text-xl font-light mt-4">Éditer la section</p>
        </Link>
      </div>
      <RepairImagesCard />
    </div>
  );
};

export default Dashboard;
